import { FaroDialog } from "@components/common/dialog/faro-dialog";
import { FaroText } from "@faro-lotv/flat-ui";
import { SphereDashboardAPITypes } from "@stellar/api-logic";

interface Props {
  /** The credit package to request quote for */
  selectedPackage: SphereDashboardAPITypes.StripeProduct;

  /** Whether the dialog is loading state while sending quote request */
  isLoading: boolean;

  /** Callback to close the dialog */
  onClose: () => void;

  /** Callback to confirm the action */
  onConfirm: () => void;
}

/**
 * Render a dialog to get confirmation before sending request for a quote.
 */
export function QuoteConfirmationDialog({
  selectedPackage,
  isLoading,
  onClose,
  onConfirm,
}: Props): JSX.Element {
  return (
    <FaroDialog
      open={true}
      title="Request a quote"
      onClose={onClose}
      onConfirm={onConfirm}
      isConfirmLoading={isLoading}
      shouldForceShowCloseButton={true}
    >
      <FaroText
        variant="bodyL"
        sx={{
          marginBottom: "24px",
          display: "block",
        }}
      >
        You are about to request a quote for{" "}
        <var>
          <strong>{selectedPackage.name}</strong>
        </var>
        .
      </FaroText>

      <FaroText variant="bodyL">Are you sure you want to proceed?</FaroText>
    </FaroDialog>
  );
}
